import axios from 'axios';
import { headers, postFileHeaders } from './headers';
import { baseUrl } from './baseUrl';

import store from '../store';
import { removeUser } from '../store/actions/userAction';
import { loginFail } from '../store/actions/loginAction';
import { openNetworkErrorModal } from '../store/actions/networkErrorModalAction';
import { openErrorModal } from '../store/actions/errorModalAction';
import { setCounterAction } from '../store/actions/countersAction';
import { incrementRequestCounterPO, incrementRequestCounterQueue, resetRequestCounterPO, resetRequestCounterQueue } from '../store/actions/counterRequestAction'

import RequestCounter from '../models/RequestCounter';

import environments from '../configs/environments';

interface GenericApi {
  post: Function;
  postFile: Function;
  get: Function;
  put: Function;
  delete: Function;
};

const genericApi: GenericApi = {

  post: (path: string, data?: any) => axios({
    method: 'post',
    url: baseUrl + path,
    headers: headers,
    withCredentials: true,
    data: JSON.stringify(data)
  })
    .then(resp => handleResponse(resp))
    .catch(error => handleError(error)),

  postFile: (path: string, data: FormData) => axios({
    method: 'post',
    url: baseUrl + path,
    headers: postFileHeaders,
    withCredentials: true,
    data: data
  })
    .then(resp => handleResponse(resp))
    .catch(error => handleError(error)),

  get: (path: string) => axios({
    method: 'get',
    url: baseUrl + path,
    headers: headers,
    withCredentials: true,
  })
    .then(resp => handleResponse(resp))
    .catch(error => handleError(error)),

  put: (path: string, data?: any) => axios({
    method: 'put',
    url: baseUrl + path,
    headers: headers,
    withCredentials: true,
    data: JSON.stringify(data)
  })
    .then(resp => handleResponse(resp))
    .catch(error => handleError(error)),

  delete: (path: string, data?: any) => axios({
    method:'delete',
    url: baseUrl + path,
    headers: headers,
    withCredentials: true,
    data: JSON.stringify(data)
  })
    .then(resp => handleResponse(resp))
    .catch(error => handleError(error))

};

function handleResponse(resp: any) {
  if(resp.data.error && resp.data.error.errorCode == '#SelectCounterError') {
    store.dispatch(setCounterAction(0))
  }
  if (resp.status === 200) {
    return resp.data;
  } else {
    // TODO:
    console.log(resp);
  }
}

function handleError(error: any) {

  if (!error.response) {

    const isPoUrl: boolean = !!(error.config.url.indexOf(baseUrl + 'pickup_orders') !== -1);
    const isQUrl: boolean = !!(error.config.url === baseUrl + 'q');
    const method: string = error.config.method;
    const counters: RequestCounter = store.getState().countersRequest;
    
    if (method === 'get' && counters.countPO < environments.maxCountRequest && isPoUrl) {
      store.dispatch(incrementRequestCounterPO());
      store.dispatch(openNetworkErrorModal());
    } else if (method === 'get' && counters.countQueue < environments.maxCountRequest && isQUrl){
      store.dispatch(incrementRequestCounterQueue());
      store.dispatch(openNetworkErrorModal());
    } else {
      store.dispatch(resetRequestCounterPO());
      store.dispatch(resetRequestCounterQueue());
    }
    const resp: any = { response: undefined };
    return resp;
  }

  const errorCode: number = error.response.status;

  switch (errorCode) {

    case 401:
      store.dispatch(loginFail());
      store.dispatch(removeUser());
      window.location = <any>'/login';
      break;
    default: 
      store.dispatch(openErrorModal(error));
      break;
  }
}

export default genericApi;